import React from 'react';
import './Input.css';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  wrapperClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, wrapperClassName = '', className = '', id, ...rest }, ref) => {
    const autoId = React.useId();
    const inputId = id ?? autoId;
    return (
      <div className={`a-input ${error ? 'a-input--error' : ''} ${wrapperClassName}`.trim()}>
        {label && <label htmlFor={inputId} className="a-input__label">{label}</label>}
        <input ref={ref} id={inputId} className={`a-input__field ${className}`.trim()} {...rest} />
        {error && <span className="a-input__error">{error}</span>}
      </div>
    );
  }
);
Input.displayName = 'Input';
